import React from 'react';
import { Label } from './ui/label';

/**
 * FormRow - A 2-column form row component
 * Column 1: Label (fixed width)
 * Column 2: Input/Control (flexible width)
 */
export const FormRow = ({ label, required, children, className = '' }) => {
  return (
    <div className={`grid grid-cols-[180px_1fr] gap-4 items-center py-3 border-b border-[var(--tms-border)] last:border-b-0 ${className}`}>
      <Label className="text-sm font-medium text-[var(--tms-text-secondary)]">
        {label}{required && <span className="text-red-500 ml-1">*</span>}
      </Label>
      <div className="min-w-0">
        {children}
      </div>
    </div>
  );
};

/**
 * FormSection - A block/section container with title
 */
export const FormSection = ({ title, icon: Icon, children, className = '' }) => {
  return (
    <div className={`bg-[var(--tms-card)] border border-[var(--tms-border)] rounded-xl p-6 mb-6 ${className}`}>
      {title && (
        <div className="flex items-center gap-3 mb-4 pb-4 border-b border-[var(--tms-border)]">
          {Icon && (
            <div className="p-2 rounded-lg bg-[var(--tms-primary)]/10">
              <Icon className="w-5 h-5 text-[var(--tms-primary)]" />
            </div>
          )}
          <h3 className="text-lg font-semibold text-[var(--tms-text)]">{title}</h3>
        </div>
      )}
      <div className="space-y-0">
        {children}
      </div>
    </div>
  );
};

/**
 * FormGrid - For side-by-side fields within a section
 */
export const FormGrid = ({ cols = 2, children, className = '' }) => {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-${cols} gap-6 ${className}`}>
      {children}
    </div>
  );
};

/**
 * ReadOnlyField - Display value without edit capability
 */
export const ReadOnlyField = ({ value, placeholder = 'Not set' }) => {
  return (
    <p className="p-2 bg-[var(--tms-hover)] rounded text-[var(--tms-text)] border border-[var(--tms-border)]">
      {value || placeholder}
    </p>
  );
};

export default FormRow;
